import { Box } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { isRebrandingEnabled } from "../../system/ui-theme";
import { LIMITED_ACCESS_INFO_FULL_PATH } from "./paths";

interface LimitedAccessBannerProps {
  leadTimeThresholdInHrs: number;
  currentScore?: number;
}

export function LimitedAccessBanner(props: LimitedAccessBannerProps) {
  const { leadTimeThresholdInHrs, currentScore } = props;

  const history = useHistory();

  const handleClick = () => {
    logEvent(APP_V2_USER_EVENTS.LIMITED_ACCESS_BANNER_CTA_TAPPED);
    history.push(LIMITED_ACCESS_INFO_FULL_PATH);
  };

  const subtitle =
    currentScore === undefined
      ? `You can claim shifts that start within ${leadTimeThresholdInHrs} hours.`
      : `You can claim shifts that start within ${leadTimeThresholdInHrs} hours. Current score: ${currentScore}.`;

  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <PromotionBanner
        title="You're on Limited Access"
        subtitle={subtitle}
        borderVariant="none"
        backgroundColor={(theme) => theme.palette.intent?.warning?.gradient ?? ""}
        titleColor={(theme) => theme.palette.intent?.warning?.text ?? ""}
        ctaButtonText="Learn more"
        ctaButtonVariant="outlined"
        sx={{
          height: "100%",
          "& .MuiButtonBase-root": isRebrandingEnabled()
            ? {
                color: (theme) => theme.palette.text.primary ?? "",
                backgroundColor: (theme) => theme.palette.background?.tertiary ?? "",
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.background?.secondary ?? "",
                },
              }
            : {
                border: "none",
                boxShadow: "none",
              },
        }}
        onClick={handleClick}
      />
    </Box>
  );
}
